'use client'
import { useContextElement } from '@/context/Context'
import Link from 'next/link'
import { useContext, useEffect, useState } from 'react'
import { Navigation } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'
import Image from 'next/image'

export default function QuickViewButton({ Product }) {
  const { setQuickViewItem } = useContextElement()

  return (
    <button
      className="pc__atc btn anim_appear-bottom btn position-absolute border-0 text-uppercase fw-medium js-quick-view"
      data-bs-toggle="modal"
      data-bs-target="#quickView"
      onClick={() => setQuickViewItem(Product)}
      title="Quick view"
    >
      <svg
        className="d-inline-blockk align-middle mx-2"
        width="14"
        height="14"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <use href="#icon_cart" />
      </svg>
      <span className="d-inline-block align-middle">加入購物車</span>
    </button>
  )
}
